import React from 'react';
import { utility } from '../../../framework/utility/utilityProvider';

const LinkedInAdPreview = (props) => {
    let { text, landingPageUrl, ad = {} } = props?.dataItem || {};
    text = text?.trim() || "Text";
    landingPageUrl = landingPageUrl?.trim() || "https://example.com";
    let image = (ad && Array.isArray(ad?.creatives)) ? ad.creatives[0]?.url : null;

    const actionButtonStyle = {
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        padding: '6px 12px',
        borderRadius: '4px',
        transition: 'background 0.2s',
        fontSize: '0.75rem',
        fontWeight: '500',
        color: '#4b5563',
    };

    const actionBarStyle = {
        borderTop: '1px solid #eee',
        display: 'flex',
        justifyContent: 'space-around',
        padding: '0.5rem 0',
        fontSize: '0.75rem',
        cursor: 'pointer',
    };

    return (
        <div style={{
            border: '1px solid #ccc',
            borderRadius: '0.5rem',
            overflow: 'hidden',
            fontFamily: 'sans-serif',
            backgroundColor: 'white',
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
        }}>
            {/* Header */}
            <div style={{ padding: '0.75rem', borderBottom: '1px solid #eee', display: 'flex', alignItems: 'center' }}>
                <i className="fa fa-linkedin-square" style={{ color: '#0A66C2', fontSize: '1.2rem', marginRight: '8px' }} />
                <span style={{ fontSize: '0.75rem', fontWeight: '600' }}>LinkedIn</span>
            </div>
            {/* Text */}
            <div style={{ padding: '0.75rem', fontSize: '0.75rem', fontWeight: '500' }}>
                {text}
            </div>
            {/* Image */}
            {image && (
                <img
                    src={image}
                    alt="LinkedIn Ad"
                    style={{
                        width: '100%',
                        height: '210px',
                    }}
                    className="img-fluid object-fit-cover"
                />
            )}
            {/* Link */}
            <div style={{ padding: '0.75rem', borderTop: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <a
                    href={landingPageUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        fontSize: '0.85rem',
                        fontWeight: '600',
                        color: '#0A66C2',
                        textDecoration: 'none',
                    }}
                >
                    {utility.subString(landingPageUrl, 30)}
                </a>
            </div>
            {/* Action Bar */}
            <div style={actionBarStyle}>
                {['Like', 'Comment', 'Repost', 'Send'].map((label, idx) => {
                    const iconMap = {
                        Like: 'fa-thumbs-o-up',
                        Comment: 'fa-comment-o',
                        Repost: 'fa-retweet',
                        Send: 'fa-paper-plane'
                    };
                    return (
                        <div
                            key={label}
                            className="linkedin-action-button"
                            style={actionButtonStyle}
                            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f3f4f6'}
                            onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                        >
                            <i className={`fa ${iconMap[label]}`} />
                            {label}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default LinkedInAdPreview;
